import { html, $ as $E, Page, on } from 'rune-ts';
import klass from './PopupStoreLanding.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { BaseLayoutOptions } from '../../../features/Core/service';
import {
  AdSection,
  ExhibitionSection,
  MotionSection,
  StatisticsSection,
  BottomSection,
  CaseSection,
  PopupStoreSection,
  PortfolioSection,
  OnlinePopupStoreEditor,
  OnlinePopupStoreEditorClosed,
} from './views';
import { PopupStoreItemCardType } from '../../../features/PopupStores/type';
import { LandingHeader, RANDING_HEADER_MENUS } from '../../components/cells/LandingHeader/LandingHeader';
import { find } from '@fxts/core';

import { isFixedElementInSection } from '../../../shared/util/elementPositionHelper';
import { ButtonCtaLanding } from '../../../shared/components/atoms/ButtonCtaLanding/ButtonCtaLanding';

export interface PopupStoreLandingData {
  layout_options: BaseLayoutOptions;
  popup_stores: PopupStoreItemCardType[];
}

export class PopupStoreLandingPage extends Page<PopupStoreLandingData> {
  motionSection = new MotionSection();
  adSection = new AdSection();
  statisticsSection = new StatisticsSection();
  exhibitionSection = new ExhibitionSection();
  caseSection = new CaseSection();
  portfolioSection = new PortfolioSection();
  popupStoreSection = new PopupStoreSection({ popup_stores: this.data.popup_stores });
  bottomSection = new BottomSection();
  ctaButton = new ButtonCtaLanding({
    type: 'white',
    label: ET('mps2::landing::popup_store::submit'),
    klass: `${klass.submit} submit`,
  });

  protected override template() {
    const { layout_options } = this.data;
    const { is_mobile } = layout_options;

    const current_menu = find((menu) => {
      return menu.name == 'Pop-up Store';
    }, RANDING_HEADER_MENUS);

    const body = html`
      <div class="${klass.container}">
        <!--   헤더     -->
        ${current_menu
          ? new LandingHeader({
              current_menu,
              is_mobile,
              popup_store_division: 'online',
            })
          : ``}

        <!--   video 모션 섹션     -->
        ${this.motionSection}

        <!--    ad 섹션    -->
        ${this.adSection}

        <!--    통계 섹션    -->
        ${this.statisticsSection}

        <!--    전시 섹션    -->
        ${this.exhibitionSection}

        <!--    Case 섹션    -->
        ${this.caseSection}

        <!--    포트폴리오 섹션    -->
        ${this.portfolioSection}

        <!--    팝업스토어 섹션    -->
        ${this.popupStoreSection}

        <!--    바텀 섹션    -->
        ${this.bottomSection}

        <!--    cta 버튼    -->
        ${this.ctaButton}
      </div>
    `;

    return html`
      <div>
        ${new LayoutView(
          {
            body,
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            require_top_arrow_button: false,
            full_width: true,
            has_bottom_tab_bar: false,
            selected_bottom_tab_idx: -1,
            ...layout_options,
          },
        )}
      </div>
    `;
  }

  openEditor() {
    const el = this.element();

    el.classList.add(klass.editing);
    document.querySelector('html, body')?.scrollTo(0, 0);

    el.after(
      new OnlinePopupStoreEditor(this.data)
        .addEventListener(OnlinePopupStoreEditorClosed, () => {
          el.classList.remove(klass.editing);
        })
        .render(),
    );
  }

  @on('click', `.submit`)
  onClickSubmitButton() {
    this.openEditor();
  }

  handleScrollChangeButtonColor() {
    if (this.ctaButton.isRendered()) {
      const $current_section = $E(this.element())
        .findAll(`.${klass.container} > section`)
        .find(($section) => isFixedElementInSection(this.ctaButton.element(), $section.element()));

      if ($current_section) {
        switch ($current_section.element()) {
          case this.motionSection.element():
          case this.adSection.element():
            this.ctaButton.setTypeOption('white');
            break;
          case this.statisticsSection.element():
          case this.exhibitionSection.element():
          case this.caseSection.element():
            this.ctaButton.setTypeOption('black');
            break;
          case this.portfolioSection.element():
            this.ctaButton.setTypeOption('blue');
            break;
          case this.bottomSection.element():
          case this.popupStoreSection.element():
            this.ctaButton.setTypeOption('hidden');
            break;
          default:
            break;
        }
      }
    }
  }

  override onRender() {
    this.handleScrollChangeButtonColor();

    document.addEventListener('scroll', () => this.handleScrollChangeButtonColor(), {
      passive: true,
    });

    if (window.visualViewport) {
      window.visualViewport.onresize = () => this.handleScrollChangeButtonColor();
    }
  }
}
